// extracted by mini-css-extract-plugin
export var formContainer = "_iu-0";
export var message = "_iu-1";